import React, { useState } from "react";
import { keyframes } from "@emotion/react";
import { Link, Heading, VStack, Box, HStack, Image, Text } from "@chakra-ui/react";
import FullScreenSection from "./FullScreenSection";
import { ChakraProvider, Flex } from "@chakra-ui/react";
import { ConversionBox } from "./ConversionBox";


// Implement the UI for the LandingSection component according to the instructions.
// Use a combination of Heading and VStack components.

const currencyFlows = [
  ["CAD", "NGN"],
  ["NGN", "CAD"],
  ["USD", "NGN"],
  ["NGN", "USD"],
  ["GBP", "NGN"],
  ["NGN", "GBP"],
  ["EUR", "NGN"],
  ["NGN", "EUR"],
  ["CAD", "USD"],
  ["USD", "CAD"],
];

const flagMap = {
  CAD: "/flags/ca.png",
  NGN: "/flags/ng.png",
  USD: "/flags/us.png",
  GBP: "/flags/gb.png",
  EUR: "/flags/eu.png",
};

const flowMarquee = keyframes`
  0% { transform: translateX(-50%); }
  100% { transform: translateX(0); }
`;

const currencyImageMap = {
  NGN: [
    { src: require('../images/abuja.png'), alt: "Abuja" },
    { src: require('../images/abujaRiver.png'), alt: "Zuma Rock" },
  ],
  CAD: [
    { src: require('../images/CanadaBanff.png'), alt: "Canada" },
    { src: require('../images/banffLake.png'), alt: "Banff Lake" },
  ],
  USD: [
    { src: require('../images/houstonAquarium.png'), alt: "Houston Aquarium" },
    { src: require('../images/nyc.png'), alt: "New York City" },
  ],
  GBP: [
    { src: require('../images/london.png'), alt: "London" },
    { src: require('../images/ukHorse.png'), alt: "United Kingdom" },
  ],
  EUR: [
    { src: require('../images/sagradaFamilia.png'), alt: "Sagrada Familia" },
    { src: require('../images/eiffelTower.png'), alt: "Eiffel Tower" },
  ],
};

const LandingSection = () => {
  const [toCurrency, setToCurrency] = useState("NGN");
  const images = currencyImageMap[toCurrency] || [];

  return (
  <FullScreenSection
    justifyContent="center"
    alignItems="center"
    isDarkBackground={false}
    backgroundImage={`url(${require('../images/landingPageBgFlipped.png')})`}
    backgroundSize="cover"
    backgroundPosition="center center"
    backgroundRepeat="no-repeat"
    py={{ base: 24, md: 24, lg: 24 }}
    overlay={true}
    overlayColor="whiteAlpha.800"
   
  >
    <VStack spacing={{ base: 4, md: 8 }} top={{ base: 0, md: "25px" }} position="relative" zIndex={1} w="100%" px={{ base: 2, md: 0 }}>
      <VStack spacing={{ base: 1, md: 3, lg: 4 }} alignItems="center" border="none" textAlign="center" w="100%">
        <Heading
          fontFamily="Lora, serif"
          fontSize={{ base: "1.7rem", lg: "3rem" }}
          fontWeight="extrabold"
        >
          Transfer money accross border in minutes
        </Heading>
        <Heading
          fontFamily="merriweather"
          fontSize={{ base: "1rem", md: "1.2rem", lg: "1.3rem" }}
          fontWeight={200}
        >
          Send, receive & convert currencies @ zero fees
        </Heading>
      </VStack>
      <ChakraProvider>
        <Flex
          minH={{ base: "auto", md: "30vh" }}
          align="center"
          justify="center"
          bg="transparent"
          position="relative"
          direction={{ base: "column", lg: "row" }}
          gap={{ base: 8, lg: 0 }}
          w="100%"
        >
         {/*} <VStack
            top={2}
            spacing={3}
            position="absolute"
            left={{ base: 0, lg: "40px" }}
            align="stretch"
            display={{ base: "none", lg: "flex" }}
          >
            {currencyFlows.map(([from, to]) => (
              <HStack
                key={`${from}-${to}`}
                spacing={2}
                bg="white"
                px={3}
                py={2}
                borderRadius="full"
                border="1px solid"
                borderColor="gray.200"
                boxShadow="sm"
              >
                <HStack spacing={1}>
                  <Box width="22px" height="16px" overflow="hidden" borderRadius="md">
                    <Image src={flagMap[from]} width="100%" height="100%" objectFit="cover" />
                  </Box>
                  <Text fontWeight="bold" fontSize={12}>{from}</Text>
                </HStack>
                <Text fontWeight="bold" fontSize={12} color="gray.600">→</Text>
                <HStack spacing={1}>
                  <Box width="22px" height="16px" overflow="hidden" borderRadius="md">
                    <Image src={flagMap[to]} width="100%" height="100%" objectFit="cover" />
                  </Box>
                  <Text fontWeight="bold" fontSize={12}>{to}</Text>
                </HStack>
              </HStack>
            ))}
          </VStack>*/}
          <Box w="100%" maxW={{ base: "100%", sm: "520px" }} px={{ base: 4, sm: 2 }}>
            <ConversionBox w="100%" defaultToCurrency={toCurrency} onToCurrencyChange={setToCurrency} />
          </Box>
          {/*<Box
            mt={{ base: 4, md: 0 }}
            w="100%"
            overflow="hidden"
            display={{ base: "block", lg: "none" }}
          >
            <Flex
              gap={3}
              whiteSpace="nowrap"
              animation={`${flowMarquee} 36s linear infinite`}
              w="max-content"
            >
              {[...currencyFlows, ...currencyFlows].map(([from, to], index) => (
                <HStack
                  key={`${from}-${to}-${index}`}
                  spacing={2}
                  bg="white"
                  px={3}
                  py={2}
                  borderRadius="full"
                  border="1px solid"
                  borderColor="gray.200"
                  boxShadow="sm"
                  flexShrink={0}
                >
                  <HStack spacing={1}>
                    <Box width="22px" height="16px" overflow="hidden" borderRadius="md">
                      <Image src={flagMap[from]} width="100%" height="100%" objectFit="cover" />
                    </Box>
                    <Text fontWeight="bold" fontSize={12}>{from}</Text>
                  </HStack>
                  <Text fontWeight="bold" fontSize={12} color="gray.600">→</Text>
                  <HStack spacing={1}>
                    <Box width="22px" height="16px" overflow="hidden" borderRadius="md">
                      <Image src={flagMap[to]} width="100%" height="100%" objectFit="cover" />
                    </Box>
                    <Text fontWeight="bold" fontSize={12}>{to}</Text>
                  </HStack>
                </HStack>
              ))}
            </Flex>
          </Box>*/}
          {images.length > 0 && (
            <VStack spacing={2} position="absolute" right={{ base: 0, lg: "32px" }} display={{ base: "none", lg: "flex" }}>
              {images.map((image, index) => (
                <Image
                  key={`${toCurrency}-${index}`}
                  src={image.src}
                  alt={image.alt}
                  width="350px"
                  height="230px"
                  borderRadius="xl"
                  boxShadow="lg"
                  objectFit="cover"
                />
              ))}
            </VStack>
          )}
        </Flex>
      </ChakraProvider>
    </VStack>
    {/* Store Buttons - Bottom Left
    <Flex direction="row" align="center" spacing={5} gap={6}
      position="absolute"
      left={{ base: 2, md: 8 }}
      bottom={{ base: 16, md: 20}}
      zIndex={2}
    >
      <Link href="#" _hover={{ transform: "translateY(-2px)" }}
        transition="0.15s ease"
        alignItems="center" w="fit-content"
      >
        <Image src="/GetItOnGooglePlay.svg" alt="Google Play" width="198px" height="70px" />
      </Link>
      <Link href="#" _hover={{ transform: "translateY(-2px)"}}
        transition="0.15s ease" alignItems="center"  w="fit-content"
      >
        <Image src="/AppStore.svg" alt="App Store" width="200px" height="60px"  />
      </Link> 
      
    </Flex> 
    */}
  </FullScreenSection>
  );
};

export default LandingSection;
